<template>
  <Modal :value="modalChangeCFOP" :onClose="cancel" size="tiny">
    <b-row align="center">
      <b-col>
        <AlertCircleOutline class="icon-2x" title="Alerta" />
      </b-col>
    </b-row>
    <b-row align="center" class="mt-2 mb-3">
      <b-col>
        <h2>Deseja alterar o CFOP dos itens relacionados a essa nota?</h2>
      </b-col>
    </b-row>
    <b-row align="center">
      <b-col>
        <Button type="cancel" @click="cancel()">
          <Close class="mb-1" title="Não" /> Não
        </Button>
        <Button @click="confirm()" type="success">Sim</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';
import Close from 'vue-material-design-icons/Close';
import AlertCircleOutline from 'vue-material-design-icons/AlertCircleOutline.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ModalConfirmCFOP',
  components: {
    Modal,
    Button,
    Close,
    AlertCircleOutline,
  },
  computed: {
    ...mapState('componentsPurchase', ['modalChangeCFOP']),
    ...mapState('purchase', [
      'products',
      'selectedNatureza',
      'taxInformation',
      'supplierInformation',
    ]),
  },
  methods: {
    ...mapActions('componentsPurchase', ['toggleModalChangeCFOP']),
    ...mapActions('purchase', [
      'setPurchase',
      'setMatchedCfopForPurchaseTaxInformation',
    ]),
    cancel() {
      this.toggleModalChangeCFOP();
      this.taxInformation.natureza = {
        ...this.selectedNatureza,
      };
    },
    async confirm() {
      if (this.supplierInformation.supplier.id) {
        await this.changeMatchedCfop();
        this.toggleModalChangeCFOP();
        return;
      }

      this.products.productOfPurchaseCollection = this.products.productOfPurchaseCollection.map(
        (e) => ({
          ...e,
          fiscal: {
            ...e.fiscal,
            ids: {
              ...e.fiscal.ids,
              cfopId: this.selectedNatureza.cfop.id,
            },
            values: {
              ...e.fiscal.values,
              cfop: {
                codigo: this.selectedNatureza.cfop.codigo,
                descricao: this.selectedNatureza.cfop.descricao,
                id: this.selectedNatureza.cfop.id,
              },
            },
          },
        }),
      );

      this.taxInformation.natureza = {
        ...this.selectedNatureza,
      };

      this.toggleModalChangeCFOP();
    },
    async changeMatchedCfop() {
      this.taxInformation.natureza = {
        ...this.selectedNatureza,
      };

      await this.setMatchedCfopForPurchaseTaxInformation({
        supplierId: this.supplierInformation.supplier.id,
        cfopIdPurchaseHeader: this.selectedNatureza.cfop.id,
      });

      this.products.productOfPurchaseCollection = this.products.productOfPurchaseCollection.map(
        (e) => ({
          ...e,
          fiscal: {
            ...e.fiscal,
            ids: {
              ...e.fiscal.ids,
              cfopId: this.taxInformation.natureza.cfop.id,
            },
            values: {
              ...e.fiscal.values,
              cfop: {
                codigo: this.taxInformation.natureza.cfop.codigo,
                descricao: this.taxInformation.natureza.cfop.descricao,
                id: this.taxInformation.natureza.cfop.id,
              },
            },
          },
        }),
      );
    },
  },
};
</script>

<style scoped>
.icon-2x {
  color: #f8bb86;
  height: 7.5em;
  width: 7.5em;
}

.icon-2x > .material-design-icon__svg {
  height: 7.5em;
  width: 7.5em;
}
</style>
